'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 -7.62939e-06C9.33334 3.30639e-05 18.6667 -3.72529e-06 28 -3.72529e-06C28 6.66666 28 13.3333 28 20C18.6667 20 9.33334 20 8.24779e-06 20L0 -7.62939e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.24779e-06 6.66666H28V-3.72529e-06L0 -7.62939e-06L8.24779e-06 6.66666Z",
          fill: "#E33F39"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.24779e-06 20H28V13.3333H8.24779e-06V20Z",
          fill: "#124BBA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.6667 10C16.6667 11.4728 15.4728 12.6667 14 12.6667C12.5272 12.6667 11.3333 11.4728 11.3333 10C11.3333 8.52724 12.5272 7.33333 14 7.33333C15.4728 7.33333 16.6667 8.52724 16.6667 10ZM16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 8.89543 12.8954 8 14 8C15.1046 8 16 8.89543 16 10Z",
          fill: "#398153"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 10.6667C14.3682 10.6667 14.6667 10.3682 14.6667 10C14.6667 9.63181 14.3682 9.33333 14 9.33333C13.6318 9.33333 13.3333 9.63181 13.3333 10C13.3333 10.3682 13.6318 10.6667 14 10.6667Z",
          fill: "#E5CF58"
        }
      )
    ]
  }
);
const VpFlagPyAsset = forwardRef(FlagPyAsset);

export { VpFlagPyAsset as default };
